import React, { useEffect, useState } from "react";
import { getClientUrlDataToken, postDataWithToken } from "../../Utils/restUtils";
import { guestComplaintStore, guestfetchBins, guestfetchType } from "../../CommonUrl";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import Transparentspinner from "../Common/Loader/Transparentspinner";

const validationSchema = yup.object().shape({
    type: yup
        .string()
        .required("Type is required"),
    mobile: yup.string()
        .matches(/^\+?\d{7,14}$/, "Enter a valid mobile number")
        .required("Mobile Number is required"),


    comments: yup
        .string().required('Comment is required')

});



const ViewComplainAdd = ({ rowData, setisOpenAdd }) => {
    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(validationSchema)
    });
    const [bins, setBins] = useState([]);
    const [types, setTypes] = useState([]);
    const [loading, setLoading] = useState(false)
    const authState = useSelector((state) => state.auth);

    const boxStyle = {
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        padding: "10px",
        borderRadius: "8px",
        backgroundColor: "#ffffff",
    };

    useEffect(() => {
        fetchBin();
        fetchType();
    }, []);

    const fetchBin = async () => {
        const response = await getClientUrlDataToken(guestfetchBins);
        if (response.status === true) {
            setBins(response.data.map(res => ({ value: res.id, type: res.stb_no })));
        }
    };

    const fetchType = async () => {
        const response = await getClientUrlDataToken(guestfetchType);
        if (response.status === true) {
            setTypes(response.data.map(res => ({ value: res.id, type: res.type })));
            console.log(response)
        }
    };

    const onSubmit = async (data) => {
        setLoading(true)
        const postData = {
            customer_id: authState?.role,
            problem_type: data?.type,
            stb_no: data?.bin,
            problem_detail: data.comments,
            phone: data.mobile,
            priority: 'high',
        };
        const response = await postDataWithToken(guestComplaintStore, postData);
        if (response?.status === 200) {
            if (response?.data?.status === true) {
                toast.success(response?.data?.message);
                rowData();
                setisOpenAdd(false);
                setLoading(false)

            } else {
                setLoading(false)
                toast.error(response?.data?.message);

            }
        }
        setLoading(false)
    };

    return (
        <div className="container mt-4">
            {
                loading && <Transparentspinner />
            }
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row justify-content-center">
                    <div className="col-md-12">
                        <div style={boxStyle}>
                            <div className="mb-3">
                                <label htmlFor="status" className="form-label blue">Bin Number</label>
                                <select id="status" {...register("bin")} className="form-select">
                                    <option value="" disabled selected>
                                        Select bin
                                    </option>
                                    {bins?.map((e, index) => (
                                        <option key={index} value={e?.type}>
                                            {e?.type}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="status" className="form-label blue">Request Type<span className="requireStar">*</span></label>
                                <select id="status" {...register("type")} className="form-select">
                                    <option value="" disabled selected>
                                        Select problem type
                                    </option>
                                    {types?.map((e, index) => (
                                        <option key={index} value={e?.type}>
                                            {e?.type}
                                        </option>
                                    ))}
                                </select>
                                <span className="text-danger " style={{ fontSize: '12px' }}>{errors.type?.message}</span>

                            </div>
                            <div className="mb-3">
                                <label htmlFor="status" className="form-label blue">Mobile Number<span className="requireStar">*</span></label>
                                <input
                                    {...register("mobile")}
                                    type="text"
                                    className="form-control"
                                    placeholder="Mobile Number"
                                />
                                <span className="text-danger " style={{ fontSize: '12px' }}>{errors.mobile?.message}</span>

                            </div>
                            <div className="mb-3">
                                <label htmlFor="comment" className="form-label blue">Comment<span className="requireStar">*</span></label>
                                <textarea {...register("comments")} className="form-control" placeholder="Add comment" rows="3"></textarea>
                                <span className="text-danger " style={{ fontSize: '12px' }}>{errors.comments?.message}</span>

                            </div>
                        </div>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col text-center">
                        <button type="submit" className="pay-all">Submit</button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default ViewComplainAdd;

